import React, { useEffect, useRef, useState } from 'react';
import { getNotificaciones, marcarNotifLeida, marcarTodasLeidas } from '../services/api';

const TIPO_ICON = { aprobada:'✅', rechazada:'❌', enviada:'📧', vista:'👁️', creada:'🟢', facturada:'⚡' };

export default function NotificationBell() {
  const [notifs, setNotifs]     = useState([]);
  const [open, setOpen]         = useState(false);
  const dropRef                 = useRef(null);

  // Si la respuesta no es un array (error, HTML, etc.) no reventamos el render.
  const load = () => getNotificaciones().then(r => setNotifs(Array.isArray(r.data) ? r.data : [])).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, []);

  // Cerrar al hacer click fuera
  useEffect(() => {
    const handler = (e) => { if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const unread = notifs.filter(n => !n.leida).length;

  const handleRead = async (n) => {
    if (!n.leida) {
      await marcarNotifLeida(n.id).catch(() => {});
      setNotifs(prev => prev.map(x => x.id === n.id ? { ...x, leida: true } : x));
    }
  };

  const handleReadAll = async () => {
    await marcarTodasLeidas().catch(() => {});
    setNotifs(prev => prev.map(x => ({ ...x, leida: true })));
  };

  return (
    <div ref={dropRef} style={s.wrap}>
      <button style={s.bell} onClick={() => setOpen(o => !o)} title="Notificaciones">
        🔔
        {unread > 0 && (
          <span style={s.badge}>{unread > 9 ? '9+' : unread}</span>
        )}
      </button>

      {open && (
        <div style={s.dropdown}>
          <div style={s.header}>
            <span style={s.headerTitle}>Notificaciones</span>
            {unread > 0 && (
              <button style={s.markAllBtn} onClick={handleReadAll}>Marcar todas leídas</button>
            )}
          </div>

          <div style={s.list}>
            {notifs.length === 0 && (
              <p style={s.empty}>Sin notificaciones</p>
            )}
            {notifs.map(n => (
              <div
                key={n.id}
                style={{ ...s.item, ...(n.leida ? {} : s.itemUnread) }}
                onClick={() => handleRead(n)}
              >
                <span style={s.icon}>{TIPO_ICON[n.tipo] || '📋'}</span>
                <div style={s.body}>
                  <p style={s.msg}>{n.mensaje}</p>
                  <p style={s.time}>{new Date(n.created_at).toLocaleString('es-CO', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' })}</p>
                </div>
                {!n.leida && <span style={s.dot} />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap:       { position:'relative' },
  bell:       { background:'transparent', border:'none', fontSize:18, cursor:'pointer', position:'relative', padding:'6px 8px', lineHeight:1, borderRadius:8 },
  badge:      { position:'absolute', top:2, right:2, background:'#ef4444', color:'#fff', borderRadius:10, fontSize:10, fontWeight:700, padding:'1px 5px', lineHeight:1.4, minWidth:16, textAlign:'center' },
  dropdown:   { position:'absolute', right:0, top:'calc(100% + 8px)', width:340, background:'#1e293b', border:'1px solid #334155', borderRadius:12, boxShadow:'0 8px 32px rgba(0,0,0,.5)', zIndex:200, overflow:'hidden' },
  header:     { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 16px', borderBottom:'1px solid #334155' },
  headerTitle:{ color:'#f1f5f9', fontSize:14, fontWeight:600 },
  markAllBtn: { background:'transparent', border:'none', color:'#60a5fa', fontSize:12, cursor:'pointer', padding:0 },
  list:       { maxHeight:380, overflowY:'auto' },
  empty:      { color:'#475569', textAlign:'center', padding:'24px 16px', fontSize:13 },
  item:       { display:'flex', alignItems:'flex-start', gap:10, padding:'12px 16px', borderBottom:'1px solid #1a2332', cursor:'pointer', transition:'background .15s' },
  itemUnread: { background:'#162032' },
  icon:       { fontSize:18, flexShrink:0, marginTop:1 },
  body:       { flex:1 },
  msg:        { color:'#cbd5e1', fontSize:13, margin:'0 0 3px', lineHeight:1.4 },
  time:       { color:'#475569', fontSize:11, margin:0 },
  dot:        { width:8, height:8, background:'#3b82f6', borderRadius:'50%', flexShrink:0, marginTop:6 },
};
